



















































































/** @format */

import ImageUploader from '@/components/img-upload/index.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mobile, idNumber } from '@root/utils/validators';

@Component({
  components: {
    ImageUploader
  }
})
export default class UserInfo extends Vue {
  /**
   * parkId
   */
  @Prop({ type: String }) parkId!: string;

  /**
   * parkId
   */
  @Prop({ type: Boolean }) isRequiredPhone!: boolean;

  @Watch('parkId')
  onChangeParkId() {
    this.$nextTick(() => {
      /**
       * 重置图片
       */
      const { resetFileList } = this.$refs.imgUpload as any;
      if (resetFileList) {
        resetFileList();
      }
    });
  }

  private validatorsPhone = mobile('请输入正确的手机号');
  private validatorsIdNumber = idNumber('请输入正确的身份证号', false);

  /**
   * 上传图片
   */
  onUploadComplete(fileUrls: any[]) {
    this.$emit('onUploadComplete', fileUrls);
  }
}
